import axios from 'axios';
import { commRequest, loginRequest} from './axiosFun';

// 登录接口 
export const login = (params) => { return loginRequest("post", "/login/login", params) };
// 获取用户菜单
export const menu = (params) => { return commRequest("get","/userauth/userinfo", params) };

/**
 * 用户管理 
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return commRequest("get", "/userauth/list", params) };
// 用户管理-获取用户信息（编辑）
export const userInfo = (params) => { return commRequest("get","/userauth/updateget", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return commRequest("post", "/userauth/addorupdate", params) };
// 用户管理-重置密码
export const userPwd = (params) => { return commRequest("post", "/userauth/updatepassword", params) };

/**
 * 模块管理
 **/
// 模块管理-获取菜单Module/list
export const ModuleList = (params) => { return commRequest("get", "/moduleauth/list", params) };
// 模块管理-获取模块信息（编辑）
export const ModuleInfo = (params) => { return commRequest("get","/moduleauth/updateget", params) };
// 模块管理-保存（添加编辑）
export const ModuleSave = (params) => { return commRequest("post", "/moduleauth/addorupdate", params) };
// 模块管理-更新子模块
export const ModuleUpdate = (params) => { return commRequest("post", "/moduleauth/updatethirdlevelmodule", params) };

/**
 * 角色管理 
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return commRequest("get", "/roleauth/list", params) };
// 角色管理-获取角色信息（编辑）
export const roleInfo = (params) => { return commRequest("get","/roleauth/updateget", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return commRequest("post", "/roleauth/addorupdate", params) };
// 角色管理-模块权限（获取）
export const RoleRightTree = (params) => { return commRequest("get", "/roleauth/modulelist", params) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return commRequest("post", "/roleauth/updaterolemodulerights", params) };

/**
 * 角色管理 - 角色数据权限 
 **/
// 角色数据权限-获取角色数据权限列表
export const roledataauthList = (params) => { return commRequest("get", "/roledataauth/list", params) };
// 角色数据权限-获取数据角色信息（编辑）
export const roledataauthInfo = (params) => { return commRequest("get","/roledataauth/updateget", params) };
// 角色数据权限-保存（添加编辑）
export const roledataauthSave = (params) => { return commRequest("post", "/roledataauth/addorupdate", params) };
// 角色数据权限-删除
export const roledataauthDelete = (params) => { return commRequest("post", "/roledataauth/delete", params) };


// WEBPACK FOOTER //
// ./src/api/userMG.js